import supportModule from '../../support.module';

export default supportModule.component('support', {
    template: require('./support.component.html')
});



// WEBPACK FOOTER //
// ./modules/support/components/support/support.component.js